import React, { useContext } from 'react';
import img from '../../../assets/Img';
import { useTranslation } from 'react-i18next';
import '../seo.css';

const translations = {
  en: require('../../../Translate/en.json').WebsiteDevelopment2.ToolsWeb,
  ar: require('../../../Translate/ar.json').WebsiteDevelopment2.ToolsWeb,
};

const ToolsWeb = () => {
  const { i18n } = useTranslation();
    const isLang = i18n.language;
  const t = translations[isLang || 'en'];

  return (
    <div className="tools-web-container" dir={isLang === 'ar' ? 'rtl' : 'ltr'}>
      <h2>
        {t.heading} <span className="highlight">Tools & Software</span>
      </h2>
      <p className="description">{t.description}</p>

      <div className="tools-icons">
        <div className="tool">
          <img width={150} src={img.tools2} alt="React Logo" />
        </div>
        <div className="tool">
          <img width={150} src={img.tools1} alt="PHP Logo" />
        </div>
        <div className="tool">
          <img width={150} src={img.tools3} alt="WPCode Logo" />
        </div>
        <div className="tool">
          <img width={150} src={img.tools4} alt="Google Analytics Logo" />
        </div>
        <div className="tool">
          <img width={150} src={img.tools5} alt="Google Search Console Logo" />
        </div>
      </div>
    </div>
  );
};

export default ToolsWeb;
